var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCalendar20 = function SvgLightIcnCalendar20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#light_icn_calendar_20_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0078FF",
    d: "M16.127 2.8h-.875V1h-1.75v1.8H6.498V1H4.75v1.8h-.875c-.972 0-1.742.81-1.742 1.801l-.009 12.604c0 .99.779 1.8 1.75 1.8h12.254c.963 0 1.75-.81 1.75-1.8V4.6c0-.99-.787-1.8-1.75-1.8m0 14.405H3.874V8.202h12.253zm-8.752-5.402H5.624v-1.8h1.75zm3.5 0h-1.75v-1.8h1.75zm3.502 0h-1.751v-1.8h1.75zm-7.002 3.601H5.624v-1.8h1.75zm3.5 0h-1.75v-1.8h1.75zm3.502 0h-1.751v-1.8h1.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "light_icn_calendar_20_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgLightIcnCalendar20;